import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Flex, Image, Text } from '@fluentui/react-northstar';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";

export interface IInMeetingAlert {
}

export interface ITaskInfo {
    action?: string;
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

export type IInMeetingAlertProps = {} & RouteComponentProps & WithTranslation;

class InMeetingAlert extends React.Component<IInMeetingAlertProps, IInMeetingAlert> {
    private localize: TFunction;

    constructor(props: IInMeetingAlertProps) {
        super(props);
        this.localize = this.props.t;
    }

    public render(): JSX.Element {
        return (
            <div className="taskModule">
                <div className="formContainer" style={{ height: "100%"}}>
                    <Flex vAlign="center" hAlign="center" gap="gap.medium" styles={{ padding: "0 3rem", textAlign: "center" }} column>
                        <Image src="/images/expired.svg" />
                        <Text
                            size="medium"
                            content={this.localize("AlertaAtendimentoExpirado")}
                        />
                    </Flex>
                </div>
            </div>
        );
    }
}

const inMeetingAlertWithTranslation = withTranslation()(InMeetingAlert);
export default inMeetingAlertWithTranslation;